import { PropsWithChildren } from "react";
import { ActiveSheet, ActiveSheetContext } from "./ActiveSheetContext";

interface ActiveSheetProviderProps {
  /**
   * The currently active sheet's metadata including a getter for the previous sheet.
   */
  sheet?: ActiveSheet;
}

export function ActiveSheetProvider({
  sheet,
  children
}: PropsWithChildren<ActiveSheetProviderProps>) {
  return (
    <ActiveSheetContext.Provider value={{ sheet }}>
      {children}
    </ActiveSheetContext.Provider>
  );
}
